import type { DetailedHTMLProps, LabelHTMLAttributes } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/form/form.css'

type LabelProps = DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & {
  htmlFor: string
}

const Label = ({ children, htmlFor, className, ...rest }: LabelProps) => {
  const classes = clsx('hot-form__label', className)

  return (
    <label htmlFor={htmlFor} className={classes} {...rest}>
      {children}
    </label>
  )
}

export default Label
